var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Invitees = YouLi.Trip.Invitees ? YouLi.Trip.Invitees : {};

(function (YouLi) {
    (function (Trip) {
        (function (Invitees) {

            RefreshFiltersForCategory = function (category) {
                YouLi.Common.UI.ShowLoading();

                const tripId = $("#TripId").val();
                const inviteeId = $("#InviteeId").val();
                const previewMode = $("#PreviewMode").val();
                const categoryVal = encodeURIComponent(category);

                let refreshFiltersURL = `/trip/updateinviteefiltersforcategory?tripid=${tripId}&inviteeId=${inviteeId}&category=${categoryVal}&preview=${previewMode}`;

                fetch(refreshFiltersURL)
                    .then(response => {
                        YouLi.Common.UI.HideLoading();

                        if (!response.ok) {
                            throw new Error('An error occurred when filtering');
                        }
                        return response.json();
                    })
                    .then(data => {
                        $("#InviteesListFilters").html(data.inviteesListFiltersHtml);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            };

            SearchInvitees = function () {
                YouLi.Common.UI.ShowLoading();

                const tripId = $("#TripId").val();
                const inviteeId = $("#InviteeId").val();
                const previewMode = $("#PreviewMode").val();
                
                const category = $("#InviteesListCategory").length == 1 ? encodeURIComponent($("#InviteesListCategory").val()) : "";

                const searchTerm = encodeURIComponent($("#InviteesListSearchTerm").val());

                let refreshFiltersURL = `/trip/updateinviteeslistforsearch?tripid=${tripId}&inviteeId=${inviteeId}&preview=${previewMode}&searchTerm=${searchTerm}&category=${category}`;

                // Add filters if and only if they have been setup
                if ($("#Filter1TaskItemFieldId").length == 1) {
                    const filter1Val = $("#InviteesListFilter1").length == 1 ? encodeURIComponent($("#InviteesListFilter1").val()) : "";
                    const filter1FieldId = encodeURIComponent($("#Filter1TaskItemFieldId").val());
                    refreshFiltersURL += `&filter1Val=${filter1Val}&filter1FieldId=${filter1FieldId}`;
                }

                if ($("#Filter2TaskItemFieldId").length == 1) {
                    const filter2Val = $("#InviteesListFilter2").length == 1 ? encodeURIComponent($("#InviteesListFilter2").val()) : "";
                    const filter2FieldId = encodeURIComponent($("#Filter2TaskItemFieldId").val());
                    refreshFiltersURL += `&filter2Val=${filter2Val}&filter2FieldId=${filter2FieldId}`;
                }

                if ($("#Filter3TaskItemFieldId").length == 1) {
                    const filter3Val = $("#InviteesListFilter3").length == 1 ? encodeURIComponent($("#InviteesListFilter3").val()) : "";
                    const filter3FieldId = encodeURIComponent($("#Filter3TaskItemFieldId").val());
                    refreshFiltersURL += `&filter3Val=${filter3Val}&filter3FieldId=${filter3FieldId}`;
                }

                fetch(refreshFiltersURL)
                    .then(response => {
                        YouLi.Common.UI.HideLoading();

                        if (!response.ok) {
                            throw new Error('An error occurred when filtering');
                        }
                        return response.json();
                    })
                    .then(data => {
                        $("#invitees-section-going-list").html(data.inviteesListHtml);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });

            };
            
            $(function () {

                $(document).on("change", "#InviteesListCategory", function () {
                    if ($(this).val() == "") {
                        $("#InviteesListFilters").html(""); // remove the filters when no category is selected
                    }
                    else {
                        RefreshFiltersForCategory($(this).val());    
                    }
                    SearchInvitees();
                });

                $(document).on("keypress", "#InviteesListSearchTerm", function (e) {
                    if (e.keyCode == 13)
                        SearchInvitees();
                });

                $(document).on("click", "#SearchButton", function () {
                    SearchInvitees();
                });
            });


        }(YouLi.Trip.Invitees ? YouLi.Trip.Invitees : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));
